<template>
    <div>
        <v-form ref="form" class="p-2">
            <v-row>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <v-select
                        v-model="item.type"
                        :items="items.types"
                        :rules="[rules.required]"
                        outlined
                        dense
                        :class="$css_field"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Tipo de vídeo</span>
                        </template>
                    </v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
                    <v-text-field
                        v-model="item.description"
                        outlined
                        dense
                        :prefix="item.type == 'YouTube' ? 'https://www.youtube.com/watch?v=' : null"
                        :class="$css_field"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">
                                <span v-if="item.type == 'YouTube'">Código vídeo</span>
                                <span v-else>Link</span>
                            </span>
                        </template>
                    </v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <v-btn
                        color="primary"
                        @click.prevent="validate()"
                        :class="$css_button"
                        :block="$vuetify.breakpoint.smAndDown"
                    >
                        Adcionar
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>

        <!-- List  --> 
        <v-row v-if="object.items" class="mt-3">
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">  
                <v-card
                    class="mx-auto"
                    outlined
                >
                    <v-data-table
                        :headers="headers"
                        :items="localItems.items"
                        :items-per-page="10"
                        sort-by="id"
                        class="elevation-1 table-striped"
                        :footer-props="{
                        'items-per-page-text':'Itens por página',
                        'items-per-page-options': [5, 10],
                        'items-per-page-all-text': '',
                        'page-text': '{0}-{1} de {2}'
                    }"
                    >
                        <template v-slot:[`item.tipo`]="{ item }">
                            <span :class="$css_report_list">{{ item.distrito }}</span>
                        </template>

                        <template v-slot:[`item.description`]="{ item }">
                            <span :class="$css_report_list">{{ item.description }}</span>
                        </template>

                        <template v-slot:[`item.actions`]="{ item }">
                            <v-card-actions>
                                <v-tooltip left>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon @click.prevent="destroy(item)" class="ml-8">
                                            <v-icon v-bind="attrs" v-on="on">mdi-delete</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Excluir</span>
                                </v-tooltip>
                            </v-card-actions>     
                        </template>

                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { TYPE_ITEMS } from './config_videos/config_videos.js'

export default {
    props: {
        object: {
            require: true,
        },
    },

    watch: {
        object: {
            handler() {
                this.setObject();           // ← configura o formulário com os dados
            },
            immediate: true // ← garante que execute mesmo se já estiver definido
        },
    },  


    data () {
        return {
            localItems: null,

            item: {
                model: '',
                item_id: '',
                type: 'YouTube',
                description: '',
            },

            items: {
                types: TYPE_ITEMS
            },

            rules: {
                required: value => !!value || 'Required.',
            },

            headers: [
                { text: 'TIPO', align: 'start', value: 'type', },
                { text: 'DESCRIÇĀO', value: 'description' },
                { text: 'AÇÕES', value: 'actions', sortable: false },
            ],
        }
    },

    methods: {
        setObject(){
            this.localItems = this.object;
        },

        validate () {
            if (this.$refs.form.validate()) {
                this.store()
            }
        },

        store(){
            this.item.model = this.localItems.model
            this.item.item_id = this.localItems.item_id
            const action = 'storeVideo'
            this.$store.dispatch(action, this.item)
                        .then(response => {
                            const result = response
                            // Verifica se já existe um colaborador com o mesmo id no array
                            const index = this.localItems.items.findIndex(c => c.id === result.id);

                            if (index > -1) {
                                // Se existir, substitui
                                this.$set(this.localItems.items, index, result);
                            } else {
                                // Se não existir, adiciona
                                this.localItems.items.push(result);
                            }

                            this.$snotify.success('Cadastro com sucesso!')
                            this.clear()
                        })
                        .catch(error => {
                            console.log(error)
                            this.$snotify.error('Erro no cadastro')
                        })
        },

       destroy(item){
            this.$store.dispatch('destroyVideo', item.id)
                        .then(response => {
                            // Encontra o índice do colaborador no array
                            const index = this.localItems.items.findIndex(c => c.id === item.id);

                            if (index > -1) {
                                // Remove reativamente do array
                                this.localItems.items.splice(index, 1);
                            }
                        })
                        .catch(error => {
                            this.$snotify.error('Erro no cadastro')
                            this.errors = error.response.data.errors
                        })
                        .finally(
                            //this.$snotify.remove()
                            this.$snotify.success('Registro excluído com sucesso!')
                        )
        },

        clear() {
            this.$refs.form.reset()
        },

    }
}        
</script>